import { useQueryParam, StringParam } from "use-query-params";

export const useSplit = () => {
  const [split, setSplit] = useQueryParam("split", StringParam);
  //@ts-ignore
  return [split, setSplit] as const;
};
